(() => {
  const config=window.CH||{}, labels=config.labels||{};
  function bindProducts(){
    document.querySelectorAll('[data-product]').forEach(section=>{
      const select=section.querySelector('[data-variant]'),data=section.querySelector('[data-variants]');
      if(!select||!data||select.dataset.bound)return;
      let variants;try{variants=JSON.parse(data.textContent)}catch{return}
      select.dataset.bound='true';
      select.addEventListener('change',()=>{
        const variant=variants.find(v=>String(v.id)===select.value);if(!variant)return;
        section.querySelector('[data-price]').textContent=variant.price;
        const add=section.querySelector('[data-add]');add.disabled=!variant.available;add.textContent=variant.available?labels.add:labels.sold;
        const payment=section.querySelector('[data-dynamic-payment]');if(payment)payment.hidden=!variant.available;
        const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState(null,'',url);
      });
    });
  }
  bindProducts();
  const dialog=document.getElementById('CookieDialog'),notice=document.getElementById('CookieNotice'),status=document.getElementById('CookieStatus');
  if(!dialog)return;
  const sessionKey='corehaven-cookie-prompt-v1';let dismissed=false,privacyPromise;
  const api=()=>window.Shopify&&window.Shopify.customerPrivacy;
  function remember(){dismissed=true;try{sessionStorage.setItem(sessionKey,'dismissed')}catch{}if(notice)notice.hidden=true}
  function wasDismissed(){if(dismissed)return true;try{return sessionStorage.getItem(sessionKey)==='dismissed'}catch{return false}}
  function hasDecision(privacy){if(!privacy||typeof privacy.currentVisitorConsent!=='function')return false;const c=privacy.currentVisitorConsent();return ['analytics','marketing','preferences'].every(k=>c&&(c[k]==='yes'||c[k]==='no'))}
  function getPrivacy(){
    if(api())return Promise.resolve(api());
    if(privacyPromise)return privacyPromise;
    privacyPromise=new Promise(resolve=>{
      let done=false;const finish=value=>{if(done)return;done=true;resolve(value)};
      if(!window.Shopify||typeof window.Shopify.loadFeatures!=='function'){finish(null);return}
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>finish(error?null:api()));
      setTimeout(()=>finish(null),8000);
    });return privacyPromise;
  }
  async function openPreferences(){
    if(window.privacyBanner&&typeof window.privacyBanner.showPreferences==='function'){
      try{await window.privacyBanner.showPreferences();return}catch{}
    }
    const privacy=await getPrivacy();
    const consent=privacy&&privacy.currentVisitorConsent?privacy.currentVisitorConsent():{};
    ['Analytics','Marketing','Preferences'].forEach(key=>{document.getElementById('Cookie'+key).checked=consent[key.toLowerCase()]==='yes'});
    status.textContent=privacy?'':labels.unavailable;
    if(!dialog.open)dialog.showModal();
  }
  function bindCookieButtons(){
    document.querySelectorAll('[data-cookie-open]').forEach(button=>{if(button.dataset.bound)return;button.dataset.bound='true';button.addEventListener('click',openPreferences)});
  }
  bindCookieButtons();
  document.querySelector('[data-cookie-close]').addEventListener('click',()=>{remember();dialog.close()});
  dialog.addEventListener('cancel',remember);
  const dismiss=document.querySelector('[data-cookie-dismiss]');if(dismiss)dismiss.addEventListener('click',remember);
  document.querySelectorAll('[data-cookie-action]').forEach(button=>button.addEventListener('click',async()=>{
    const privacy=await getPrivacy();if(!privacy){status.textContent=labels.unavailable;if(!dialog.open)dialog.showModal();return}
    const action=button.dataset.cookieAction;
    const chosen=key=>action==='accept'||(action==='save'&&document.getElementById('Cookie'+key).checked);
    privacy.setTrackingConsent({analytics:chosen('Analytics'),marketing:chosen('Marketing'),preferences:chosen('Preferences'),sale_of_data:false},result=>{
      if(result&&result.error){status.textContent=labels.unavailable;return}
      remember();status.textContent=labels.saved;if(dialog.open)dialog.close();
    });
  }));
  if(config.autoCookie)getPrivacy().then(privacy=>{if(!privacy||wasDismissed()||hasDecision(privacy))return;if(privacy.shouldShowBanner&&privacy.shouldShowBanner())notice.hidden=false});
  document.addEventListener('shopify:section:load',()=>{bindProducts();bindCookieButtons()});
})();
